import { PalmettoLink } from '@palmetto/dsm-components';

export function CustomerDirectPaymentFooter() {
  return (
    <div className="flex flex-col items-center gap-4">
      <span className="body-200 text-text-tertiary">Questions? We&apos;re here to help.</span>
      <div className="flex items-center gap-16">
        <PalmettoLink href="mailto:help@golightreach.com" size="sm" className="!text-btn-content-text-idle">
          help@golightreach.com
        </PalmettoLink>
        <PalmettoLink href="tel:8005978527" size="sm" className="!text-btn-content-text-idle">
          (800) 597 8527
        </PalmettoLink>
      </div>
    </div>
  );
}
